// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"outbox"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 21L21 21L21 15.5L15.7092 15.5C15.1159 16.9659 13.6787 18 12 18C10.3213 18 8.88415 16.9659 8.29076 15.5L3 15.5L3 21Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 21V3L3 3L3 21M21 21H3M21 21L21 15.5H15.7092C15.1159 16.9659 13.6787 18 12 18C10.3213 18 8.88415 16.9659 8.29076 15.5H3L3 21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 9.5L12 6.5L15 9.5M12 13V7.25","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-outbox')
export default class OutboxIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'outbox',
    }
  }
}
